import styled from 'styled-components';

import InternalLink from 'components/InternalLink';
import colors from '../../../../../constants/colors';

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const ActivitiesStats = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  color: ${colors.main.placeholdersAndDisabledBtnsText};
`;

export const SectionLink = styled(InternalLink)`
  text-align: right;

  @media screen and (max-width: 992px) {
    text-align: left;
  }

  @media screen and (min-width: 765px) and (max-width: 992px) and (orientation: portrait) {
    text-align: right;
  }
`;

interface ActivityGridProps {
  withColumns?: boolean;
}

export const ActivityGrid = styled.div<ActivityGridProps>`
  display: grid;
  ${({ withColumns }) =>
    withColumns ? 'grid-template-columns: 1fr 1fr;' : 'grid-template-columns: 1fr;'}
  grid-gap: 24px;
  margin-bottom: 24px;

  @media screen and (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 16px;
  padding: 72px 32px;
  margin: 0 auto;
  max-width: 480px;

  @media screen and (max-width: 992px) {
    padding: 56px 24px;
    min-height: calc(100vh - 450px);
    width: 89.3%;
  }

  @media screen and (max-width: 992px) and (orientation: landscape) {
    min-height: auto;
  }
`;

export const EmptyDescription = styled.div`
  max-width: 360px;
`;

export const NextUpCta = styled.a`
  margin-top: 12px;
  padding: 14px 18px;
  background: rgba(14, 160, 195, 0.04);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  max-width: 360px;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: rgba(14, 160, 195, 0.08);
  }

  &:focus-visible {
    outline: 2px solid ${colors.main.blue};
    outline-offset: 2px;
  }
`;

export const NextUpInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const NextUpLabel = styled.div`
  font-size: 11px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${colors.main.grey};
`;

export const NextUpTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${colors.main.black};
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const NextUpArrow = styled.div`
  font-size: 18px;
  color: ${colors.main.blue};
  flex-shrink: 0;
`;
